export const devices = [
  {
    name: 'M300 Dual',
    id: 'm300dual',
    technology: 'lpd'

  },
  {
    name: 'M300 Plus',
    id: 'm300plus',
    technology: 'lpd'

  },
  {
    name: 'M200 Plus',
    id: 'm200plus',
    technology: 'lpd'
  },
  {
    name: 'Inventure',
    id: 'inventure',
    technology: 'lpd'

  },
  {
    name: 'Inkspire 2',
    id: 'inkspire2',
    technology: 'uvLcd'
  },
  {
    name: 'Cleaning Station',
    id: 'cleaningstation',
    technology: 'uvLcd'
  },
  {
    name: 'Curing Station',
    id: 'curingstation',
    technology: 'uvLcd'
  },
  {
    name: 'Apoller',
    id: 'apoller',
    technology: 'lpd'
  },
  {
    name: 'Endureal',
    id: 'endureal',
    technology: 'industrial'

  },
];

export const devices_service = [
  {
    name: 'M300 Dual',
    id: 'm300dual',
    technology: 'lpd'

  },
  {
    name: 'M300 Plus',
    id: 'm300plus',
    technology: 'lpd'

  },
  {
    name: 'M200 Plus',
    id: 'm200plus',
    technology: 'lpd'
  },
  {
    name: 'Inventure',
    id: 'inventure',
    technology: 'lpd'

  },
  {
    name: 'Inkspire',
    id: 'inkspire',
    technology: 'uvLcd'
  },
  {
    name: 'Inkspire 2',
    id: 'inkspire2',
    technology: 'uvLcd'
  },
  {
    name: 'Cleaning Station',
    id: 'cleaningstation',
    technology: 'uvLcd'
  },
  {
    name: 'Curing Station',
    id: 'curingstation',
    technology: 'uvLcd'
  },
  {
    name: 'Apoller',
    id: 'apoller',
    technology: 'lpd'
  },
  {
    name: 'Endureal',
    id: 'endureal',
    technology: 'industrial'

  },
];
